module.exports = __webpack_public_path__ + "static/media/bg-image-39.34c6010a.jpg";